import { SubmitSurveyType } from '@propTypes/surveyTypes';
import ApiLpc from '@services/http/ApiLpc';
import { axiosClient } from '@services/http/Http';

const submitSurvey = (body: SubmitSurveyType, ctx?: string) =>
    axiosClient(ctx).post(ApiLpc.SURVEY.SEND_SURVEY, JSON.stringify(body));

const surveyService = {
    submitSurvey,
};

export default surveyService;
